import { parseAccent, themeVariables, type ThemeMode } from "@planner/core";
import { platform } from "../platform/index.js";

/**
 * يطبّق التوكنز على الجذر — **مرة واحدة، فيتغيّر النظام كلّه**.
 *
 * هذه هي الآلية التي تجعل «المشتري يختار لونه» قراراً بنيوياً لا وعداً: لا يوجد
 * لونٌ مكتوب في أي ملف تنسيق، فما من شيء يمكن أن ينسى التغيّر معه.
 */
export function applyTheme(accentHex: string, mode: ThemeMode): void {
  const root = platform.documentElement;
  if (!root) return;
  const variables = themeVariables(parseAccent(accentHex), mode);
  for (const [name, value] of Object.entries(variables)) root.style.setProperty(name, value);
  root.dataset["theme"] = mode;
  root.style.colorScheme = mode;
  /** **وشريطُ المتصفّح معها** — فاللونُ واحدٌ داخل الصفحة وحولها */
  platform.setThemeColor(variables["--accent"] ?? accentHex);
}

const STORED_MODE = "planner.theme";

/** ما يختاره المستخدم يسبق تفضيل نظامه؛ وبلا اختيارٍ يتبع نظامه */
export function preferredMode(): ThemeMode {
  const stored = platform.readPreference(STORED_MODE);
  if (stored === "light" || stored === "dark") return stored;
  return platform.preferredColorScheme();
}

export function rememberMode(mode: ThemeMode): void {
  platform.writePreference(STORED_MODE, mode);
}
